import api from './api'

const resource = '/logs'

export default {
    get(page, q, per_page, start_date, end_date) {
        return api.get(`${resource}?page=${page}&q=${q}&per_page=${per_page}&start_date=${start_date}&end_date=${end_date}`);
    }
}